import moment from "moment-timezone";
import DataTable from "react-data-table-component";

const ReturnOrderList = ({ retunrOrderRequestData, onShowDetails }) => {
  const handleTextColor = (row) => {
    return {
      color:
        row.status === "pending"
          ? "orange"
          : row.status === "approved"
          ? "green"
          : row.status === "rejected"
          ? "red"
          : "#ffc60b",
      fontWeight: "bold",
      textTransform: "capitalize",
    };
  };
  const columnDefs = [
    {
      name: "Order ID",
      selector: (row) => row?.orderDetailId?.orderId?.orderid,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Username",
      selector: (row) => row?.userId?.username,
      sortable: true,
    },
    {
      name: "Single Item Price",
      selector: (row) => `€ ${row?.orderDetailId?.price.toFixed(2)}`,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <span style={handleTextColor(row)}>{row?.status}</span>
      ),
      sortable: true,
    },
    {
      name: "Date/Time",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm:ss"),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Action",
      minWidth: "150px",
      cell: (row) => (
        <button
          className="btn btn-primary "
          onClick={() => onShowDetails?.(row)}>
          Show Details
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <DataTable
        data={retunrOrderRequestData}
        columns={columnDefs}
        pagination
        selectableRows={false}
        onSelectedRowsChange={(e) => console.log("Selected Rows:", e)}
      />
    </div>
  );
};

export default ReturnOrderList;
